import { create } from 'zustand';
import _cloneDeep from 'lodash/cloneDeep';
import { getAppStore } from '@src/utils/store-reference';
import { pcnRequiredValues } from '@src/app-pages/Forms/input-forms/NonPcnForm/nonPcnData.types';

interface NonPcnStoreValues {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  nonPcnData: any;
  nonPcnId: number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  nonPcnErrors: any;
  nonPcnResult: string;
}

interface NonPcnState extends NonPcnStoreValues {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setNonPcnRequest: (nonPcn: any) => void;
  resetNonPcnState: () => void;
  setNonPcnId: (nonPcnId: number) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setNonPcnErrors: (nonPcnErrors: any) => void;
  setNonPcnResult: (nonPcnResult: string) => void;
}

const defaults: NonPcnStoreValues = {
  nonPcnData: {},
  nonPcnId: 0,
  nonPcnErrors: null,
  nonPcnResult: '',
};

export const useNonPcn = create<NonPcnState>((set, get) => ({
  ..._cloneDeep(defaults),
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setNonPcnRequest: (nonPcnData: any) => {
    const store = getAppStore();
    const data = { ...get().nonPcnData, ...nonPcnData };
    // Set data nonPcnResult to latest store value
    data.nonPCNResult = get().nonPcnResult;
    // Set nwpGenInSetRequiringPCN value dependent on nwpPermitType
    data.nwpGenInSetRequiringPCN = data?.nwpPermitTypeID
      ? pcnRequiredValues.includes(data?.nwpPermitTypeID)
        ? 'Yes'
        : 'No'
      : null;
    // Set Non-PCN data store
    set({ nonPcnData: data });
    set({ nonPcnId: data?.nonPcnRequestID });
    // Set Request Object data store (Redux)
    store.doUpdateRequestObject({ nonPCNRequests: [data] });
  },
  resetNonPcnState: () => set(_cloneDeep(defaults)),
  setNonPcnId: (nonPcnId: number) => set({ nonPcnId }),
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setNonPcnErrors: (nonPcnErrors: any) => set({ nonPcnErrors }),
  setNonPcnResult: (nonPcnResult: string) => set({ nonPcnResult }),
}));
